var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.532059","y":"6.32947","width":"16.8249","height":"3.51647","key":0}),React.createElement("rect",{"width":"11.2347","height":"3.51084","transform":"matrix(0.705971 -0.708241 0.705971 0.708241 10.3465 13.5833)","key":1}),React.createElement("rect",{"width":"11.2347","height":"3.51084","transform":"matrix(0.705971 0.708241 -0.705971 0.708241 12.8259 0)","key":2})]);
}

ArrowInline.defaultProps = {"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none","className":"icon"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
